import { BLACK_e } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  height: 104.4rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column;
    height: 120rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  flex: 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: 1s;
  align-items: center;
  flex-direction: column;
  & > img {
    position: absolute;
    height: 111.6rem;
    width: 131rem;
    z-index: -99;
    left: 0;
    left: -20rem;
  }

  & > div:nth-child(2) {
    display: none;
    position: absolute;
    width: 111rem;
    height: 104.4rem;
    left: 0rem;
    top: 0rem;
    background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    transition: 1s;
    z-index: -98;
  }

  & > span {
    &:nth-child(3) {
      margin-bottom: 1rem;
      font-weight: 700;
      font-size: 3rem;
      line-height: 4rem;
    }
    &:nth-child(4) {
      font-weight: 700;
      font-size: 3rem;
      line-height: 4rem;
    }
    &:nth-child(5) {
      display: none;
    }
  }

  &:hover {
    align-items: baseline;
    flex: 5;

    & > img {
    }
    & > div:nth-child(2) {
      display: block;
    }

    & > span {
      width: 80%;
      margin: 0 auto;
      &:nth-child(3) {
        font-size: 4rem;
        line-height: 7rem;
      }
      &:nth-child(4) {
        font-size: 5.2rem;
        line-height: 8.2rem;
      }
      &:nth-child(5) {
        margin-top: 5rem;
        font-weight: 300;
        font-size: 2rem;
        line-height: 3.6rem;
        color: ${BLACK_e};
        white-space: nowrap;
        display: flex;
        flex-direction: column;
      }
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > img {
      width: 80rem;
      height: 70rem;
      left: -20rem;
    }
    & > span {
      &:nth-child(3) {
        margin-top: 0.5rem;
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3rem;
      }
      &:nth-child(4) {
        font-size: 2.2rem;
        line-height: 3rem;
      }
      &:nth-child(5) {
        display: none;
      }
    }
    &:hover {
      flex: 1.5;
      flex-direction: column;
      & > div:nth-child(2) {
        display: block;
      }

      & > span {
        margin-left: 20px;
        padding-right: 20px;
        &:nth-child(3) {
          font-size: 2.2rem;
          line-height: 3rem;
        }
        &:nth-child(4) {
          font-size: 2.2rem;
          line-height: 3rem;
        }
        &:nth-child(5) {
          margin-top: 1.5rem;
          font-size: 1.6rem;
          line-height: 2.8rem;
          white-space: normal;
          display: block;
        }
      }
    }
  }
`;
